var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-info",on:{"click":_vm.refresh}},[_c('span',{staticClass:"fa fa-refresh"})])
}
var staticRenderFns = []

export { render, staticRenderFns }